import React, { PropTypes } from 'react';
import Article from './Article';

const isBrowser = typeof window !== 'undefined';
const WOW = (isBrowser) ? require('wow.js') : undefined;

class Articles extends React.Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      const wow = new WOW(
        {
          boxClass: 'wow',      // animated element css class (default is wow)
          animateClass: 'animated', // animation css class (default is animated)
          offset: 0, // distance to the element when triggering the animation (default is 0)
          mobile: true,       // trigger animations on mobile devices (default is true)
          live: true,       // act on asynchronously loaded content (default is true)
          scrollContainer: 'section', // optional scroll container selector, otherwise use window
        }
      );
      wow.init();
    }
  }

  render() {
    const { lang, items } = this.props;
    return (
      <div className="articlesContainer" >
      {items.map((item, i) =>
        <Article
          key={i}
          lang={lang}
          item={item}
          isLast={(i === items.size - 1)}
        />)}
      </div>
    );
  }
}

Articles.propTypes = {
  lang: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
};

export default Articles;



// WEBPACK FOOTER //
// ./common/components/Articles.js